/*
 * Movimentos do caixa: { descricao, valor, tipo: "Entrada" | "Saída" }.
 *
 * O saldo é a soma dos valores com sinal. "Saída" sempre subtrai, mesmo se
 * foi gravada com valor positivo — o estorno de venda do PDV gravava assim
 * até a 1.3.4, e esses lançamentos apareciam como entrada.
 */

export const valorCaixa = (mov) => {
  const valor = parseFloat(mov?.valor) || 0;
  return mov?.tipo === "Saída" ? -Math.abs(valor) : valor;
};

export const somarCaixa = (lista) =>
  Math.round((lista || []).reduce((soma, mov) => soma + valorCaixa(mov), 0) * 100) / 100;

// Para o extrato (mais recente primeiro). created_at nulo = gravação ainda
// pendente no Firestore, ou seja, acabou de ser feita.
export const dataCaixa = (mov) =>
  mov?.created_at?.toMillis?.() ?? (Date.parse(mov?.data) || (mov?.created_at === null ? Infinity : 0));
